import React from 'react';
export function PainPointsSection() {
  const points = [{
    emoji: '😰',
    text: 'Llegas a clase sin saber exactamente qué actividad dar hoy'
  }, {
    emoji: '⏱️',
    text: 'Tardas horas planificando lo que podrías resolver en minutos'
  }, {
    emoji: '🤷',
    text: 'No sabes cómo evaluar objetivamente el progreso musical'
  }, {
    emoji: '📚',
    text: 'Sientes que enseñas lo mismo todos los años y te aburres'
  }, {
    emoji: '😓',
    text: 'Tus alumnos están desmotivados con la teoría musical tradicional'
  }];
  return <section className="py-20 px-4 bg-[#f4ece1]" data-id="element-98">
      <div className="max-w-3xl mx-auto text-center" data-id="element-99">
        <h2 className="text-3xl md:text-4xl font-black text-brand-text mb-4" data-id="element-100">
          👉 ¿Te reconoces en estas situaciones?
        </h2>
        <p className="text-brand-gray mb-12 text-lg" data-id="element-101">
          Si respondes sí a alguna — este pack es para ti
        </p>

        <div className="space-y-4 mb-12" data-id="element-102">
          {points.map((point, i) => <div key={i} className="bg-white rounded-2xl p-6 shadow-sm flex items-center gap-5 text-left border border-white/50 hover:border-brand-creamDark transition-colors" data-id="element-103">
              <span className="text-3xl shrink-0" data-id="element-104">{point.emoji}</span>
              <span className="text-brand-text font-medium md:text-lg" data-id="element-105">
                {point.text}
              </span>
            </div>)}
        </div>

        <p className="text-xl md:text-2xl font-serif italic text-brand-red font-bold" data-id="element-106">
          Y tú mereces disfrutar de enseñar →
        </p>
      </div>
    </section>;
}